import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NotbankService } from '../../../../../services/notbank.service';
import { buildCopCashoutDraft } from '../cashout-draft-builders';
import { CashoutDraft } from '../cashout-currency.types';
import {
  BREB_KEY_TYPE_OPTIONS,
  getCopBeneficiaryBankOptions,
  isCopBitsoBankSelected,
  isCopDocumentMissing,
  isCopMinteoBankSelected,
  MINTEO_COP_CHANNEL_OPTIONS,
  MINTEO_ORIGIN_WALLETS,
  onCopBankPicked,
  setupCopCashoutForm,
  updateCopMinteoValidators,
} from './cop-form.logic';
import {
  NOTBANK_KIND_OPTIONS,
  createNotbankBankFormGroup,
  isNotbankBankSelected,
  unwrapNotbankList,
  updateNotbankBankValidators,
} from '../notbank-cashout.logic';

@Component({
  selector: 'app-cop-form',
  templateUrl: './cop-form.component.html',
  styleUrl: '../../add-cashout.component.scss',
})
export class CopFormComponent implements OnInit, OnDestroy {
  @Input() ctx!: any;
  @Output() draftReady = new EventEmitter<CashoutDraft>();

  readonly minteoCopChannelOptions = MINTEO_COP_CHANNEL_OPTIONS;
  readonly brebKeyTypeOptions = BREB_KEY_TYPE_OPTIONS;
  readonly minteoOriginWallets = MINTEO_ORIGIN_WALLETS;
  readonly notbankKindOptions = NOTBANK_KIND_OPTIONS['CO'] || [];

  notbankBanks: any[] = [];
  loadingNotbankBanks = false;
  private bankWatch?: Subscription;

  constructor(
    private notbankService: NotbankService,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    if (!this.ctx.newTransactionForm.get('notbank_bank')) {
      this.ctx.newTransactionForm.addControl(
        'notbank_bank',
        createNotbankBankFormGroup(this.fb),
      );
    }
    setupCopCashoutForm(this.ctx);
    this.bankWatch = this.ctx.newTransactionForm.controls.company_id.valueChanges.subscribe(
      () => {
        if (this.isNotbankBankSelected()) {
          this.loadNotbankBanks();
          updateNotbankBankValidators(this.notbankGroup, 'COP');
        }
      },
    );
    if (this.isNotbankBankSelected()) {
      this.loadNotbankBanks();
      updateNotbankBankValidators(this.notbankGroup, 'COP');
    }
  }

  ngOnDestroy(): void {
    this.bankWatch?.unsubscribe();
  }

  get notbankGroup(): FormGroup {
    return this.ctx.newTransactionForm.get('notbank_bank') as FormGroup;
  }

  isCopMinteoBankSelected(): boolean {
    return isCopMinteoBankSelected(this.ctx);
  }

  isCopBitsoBankSelected(): boolean {
    return isCopBitsoBankSelected(this.ctx);
  }

  isNotbankBankSelected(): boolean {
    return isNotbankBankSelected(this.ctx);
  }

  copBeneficiaryBankOptions(): any[] {
    return getCopBeneficiaryBankOptions(this.ctx);
  }

  isCopDocumentMissing(): boolean {
    return isCopDocumentMissing(this.ctx);
  }

  onMinteoChannelChange(): void {
    updateCopMinteoValidators(this.ctx);
  }

  onNotbankKindChange(): void {
    updateNotbankBankValidators(this.notbankGroup, 'COP');
  }

  loadNotbankBanks(): void {
    this.loadingNotbankBanks = true;
    this.notbankService.getBanks({ currency: 'COP' }).subscribe({
      next: (resp: any) => {
        this.loadingNotbankBanks = false;
        this.notbankBanks = unwrapNotbankList(resp).map((b: any) => ({
          ...b,
          label: b.name || b.bank_name || b.id,
        }));
      },
      error: () => {
        this.loadingNotbankBanks = false;
        this.notbankBanks = [];
      },
    });
  }

  pickBank(event: any): void {
    this.ctx.pickBank(event);
    onCopBankPicked(this.ctx);
    if (this.isNotbankBankSelected()) {
      this.loadNotbankBanks();
      updateNotbankBankValidators(this.notbankGroup, 'COP');
    }
  }

  saveTransaction(): void {
    const draft = buildCopCashoutDraft(this.ctx);
    if (draft) {
      this.draftReady.emit(draft);
    }
  }
}
